import {SkillLevel, SkillLevelRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_GRIS} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";

export const SkillLevelListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(SkillLevelRestControllerApiFactory);

	const listConfig: AppListConfig<SkillLevel> = {
		title: "Listado de niveles de habilidad ",
		onClick: "/app/admin/recruitment/skilllevel",
		headers: [
			{title: "Nombre"},
			{title: "Nivel"},
		],
		decorator: (bean: SkillLevel) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_GRIS : ""}}>
					{bean.label}
				</TableCell>
				<TableCell>
					{bean.level}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			return ctrl.pageSkillLevel(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};